export default function (componentImport: any, name: string) {
    return new Promise((resolve, reject) => {
        const storageKey = `retry-lazy-${name}-refreshed`;
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem(storageKey) || 'false',
        );
        // try to import the component
        componentImport()
            .then((component: any) => {
                window.sessionStorage.setItem(storageKey, 'false'); // success so reset the refresh
                resolve(component);
            })
            .catch((error: any) => {
                if (!hasRefreshed) {
                    // not been refreshed yet
                    window.sessionStorage.setItem(storageKey, 'true'); // we are now going to refresh
                    return window.location.reload(); // refresh the page
                }
                reject(error); // Default error behavior as already tried refresh
            });
    });
}
